import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SettingConstants {
  static readonly RequireConfirmedEmail = 'Abp.Identity.SignIn.RequireConfirmedEmail';

  static readonly MorphingEnabled = 'VoiceMorphing.Enabled';

  static readonly InteractionManagementEnabled = 'InteractionManagement.Enabled';
}
